import React, { useState } from 'react';
import { apiFetch } from './api';

export default function ChangePasswordModal({ userEmail, required, onSuccess, onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext]       = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError]     = useState('');
  const [saving, setSaving]   = useState(false);

  const passwordsMatch = next === confirm;
  const valid = next.length >= 8 && passwordsMatch && current.length > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!valid) return;
    setSaving(true);
    setError('');
    try {
      const res = await apiFetch(`/api/users/${encodeURIComponent(userEmail)}/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ currentPassword: current, newPassword: next }),
      });
      if (res.status === 204) {
        onSuccess();
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || 'An error occurred. Please try again.');
      }
    } catch {
      setError('Unable to reach the server.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cpw-backdrop">
      <div className="cpw-card">
        <div className="cpw-header">
          {required ? 'Set Your Password' : 'Reset Password'}
        </div>
        <div className="cpw-body">
          {required && (
            <div className="alert alert-warning py-2 mb-3" style={{ fontSize: '0.875rem' }}>
              You must choose a new password before continuing.
            </div>
          )}
          {error && (
            <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '0.875rem' }}>{error}</div>
          )}
          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label className="form-label">Current Password</label>
              <input
                type="password"
                className="form-control"
                value={current}
                onChange={e => setCurrent(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">New Password</label>
              <input
                type="password"
                className="form-control"
                value={next}
                onChange={e => setNext(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
              />
              <div className="form-text">Minimum 8 characters.</div>
            </div>
            <div className="mb-4">
              <label className="form-label">Confirm New Password</label>
              <input
                type="password"
                className={`form-control${confirm && !passwordsMatch ? ' is-invalid' : ''}`}
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                autoComplete="new-password"
                required
              />
              {confirm && !passwordsMatch && (
                <div className="invalid-feedback">Passwords do not match.</div>
              )}
            </div>
            <div className="d-flex gap-2 justify-content-end">
              {!required && (
                <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                  Cancel
                </button>
              )}
              <button type="submit" className="btn btn-primary" disabled={saving || !valid}>
                {saving ? 'Saving\u2026' : 'Save Password'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
